import HeroSlider from "@/components/HeroSlider";
import CourseCategoriesSection from "@/components/CourseCategoriesSection";
import ProductsSection from "@/components/ProductsSection";
import MediaSection from "@/components/MediaSection";
import AboutSection from "@/components/AboutSection";
import CtaSection from "@/components/CtaSection";
import ContactTabbedSection from "@/components/ContactTabbedSection";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function HomePage({ onOpenAuth }) {
    const { hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
            }
        }
    }, [hash]);

    return (
        <div className="min-h-screen bg-paper">
            <Navbar onOpenAuth={onOpenAuth} />
            <main>
                <HeroSlider />
                <CourseCategoriesSection />
                <ProductsSection />
                <MediaSection />
                <AboutSection />
                <CtaSection />
                <ContactTabbedSection />
            </main>
            <Footer />
        </div>
    );
}
